import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogBusiness } from "../../../../store/catalog/actions";
export var useGetCatalogBusinessType = function (trigger) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseCatalogBusiness: (_a = state.Catalog.responseCatalogBusiness) === null || _a === void 0 ? void 0 : _a.data,
            loadingCatalogBusiness: state.Catalog.loadingCatalogBusiness,
            errorCatalogBusiness: state.Catalog.errorCatalogBusiness,
        });
    }), responseCatalogBusiness = _a.responseCatalogBusiness, loadingCatalogBusiness = _a.loadingCatalogBusiness, errorCatalogBusiness = _a.errorCatalogBusiness;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogBusiness({
                enable: true,
                page: 1,
                limit: 1000,
                type: "CATALOG_TYPE_BUSINESS",
            }));
        }
    }, [trigger]);
    return {
        responseCatalogBusiness: responseCatalogBusiness,
        loadingCatalogBusiness: loadingCatalogBusiness,
        errorCatalogBusiness: errorCatalogBusiness,
    };
};
